import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('/api/v1/auth/tokens', () => {
    return HttpResponse.json({ items: [] });
  }),
  http.get('/api/v1/auth/tokens/:authTokenId', () => {
    return HttpResponse.json({});
  }),
];

export default handlers;
